import React, { Component } from 'react';
import get from 'lodash/get';
import ConfirmationLayout from 'shared/lib/components/ConfirmationLayout';
import LineItemsList from 'shared/lib/components/LineItemsList';
import SectionWrapper from 'shared/lib/components/SectionWrapper';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import * as analytics from 'shared/lib/analytics';

const propTypes = {
  account: PropTypes.object,
  extensionReturnDate: MomentPropTypes.momentObj,
  policy: PropTypes.object,
  totals: PropTypes.object,
};

const defaultProps = {
  account: {},
  extensionReturnDate: {},
  policy: {},
  totals: {},
};

class RentalCarExtensionConfirmation extends Component {

  componentDidMount() {
    analytics.page('Rental Car - Confirmation - Extension');
    analytics.track('Checkout Step Viewed', {
      category: 'order',
      step: 3,
    });
  }

  render() {
    const {
      account,
      extensionPolicy,
      extensionReturnDate,
      policy,
      totals,
    } = this.props;

    return (
      <div className="RentalCarExtensionConfirmation Container Container--small">
        <ConfirmationLayout
          policyNumber={extensionPolicy.rental_agreement_number}
          policyDocUrl={extensionPolicy.sample_policy}
          icon="directions_car"
          totals={totals}
          phoneNumber={account.phoneNumber}
        >
          <SectionWrapper title="Rental car details">
            <LineItemsList
              rows={[
                ['Original return date', moment(get(policy, 'details.rental_ended'), 'YYYY-MM-DD').format('MMM D, YYYY')],
                ['New return date', extensionReturnDate && extensionReturnDate.tz('UTC').format('MMM D, YYYY')],
              ]}
            />
          </SectionWrapper>

          <SectionWrapper title="Coverage details">
            <LineItemsList
              rows={[
                ['Underwritten by', 'Chubb'],
                ['Start date', moment(get(policy, 'details.rental_started'), 'YYYY-MM-DD').format('MMM D, YYYY')],
                ['End date', extensionReturnDate && extensionReturnDate.tz('UTC').format('MMM D, YYYY')],
              ]}
            />
          </SectionWrapper>
        </ConfirmationLayout>
      </div>
    );
  }
}

RentalCarExtensionConfirmation.propTypes = propTypes;
RentalCarExtensionConfirmation.defaultProps = defaultProps;

export default RentalCarExtensionConfirmation;
